import { ItemdetailsCandeactiveGuardService } from './services/itemdetails-candeactive-guard.service';
import { environment } from './../environments/environment';
import { BrowserModule } from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {ReactiveFormsModule} from '@angular/forms';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { MenuComponent } from './menu/menu.component';
import { ToolbarComponent } from './toolbar/toolbar.component';
import { InfoComponent } from './info/info.component';
import { ItemslistComponent } from './itemslist/itemslist.component';
import { WarehousesComponent } from './warehouses/warehouses.component';
import { PieChartComponent } from './piechart/piechart.component';
import { ChartsModule } from 'ng2-charts';
import { MapsComponent } from './maps/maps.component';
import { ItemdetailsComponent } from './itemdetails/itemdetails.component';

import { AngularFireModule } from 'angularfire2';
import { AngularFirestoreModule } from 'angularfire2/firestore';
import { AngularFireAuthModule } from 'angularfire2/auth';
import { AngularFireStorage} from 'angularfire2/storage';


import { StatusinfoDirective } from './shared/statusinfo.directive';
import { HistoryComponent } from './history/history.component';
import { LoginpageComponent } from './loginpage/loginpage.component';

import { LOCALE_ID } from '@angular/core';
import { registerLocaleData } from '@angular/common';
import localePl from '@angular/common/locales/pl';
import { RenameDialogComponent } from './shared/rename-dialog/rename-dialog.component';

import {MatAutocompleteModule} from '@angular/material/autocomplete';
import {MatBadgeModule} from '@angular/material/badge';
import {MatBottomSheetModule} from '@angular/material/bottom-sheet';
import {MatButtonModule} from '@angular/material/button';
import {MatButtonToggleModule} from '@angular/material/button-toggle';
import {MatCardModule} from '@angular/material/card';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatChipsModule} from '@angular/material/chips';
import {MatStepperModule} from '@angular/material/stepper';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatDialogModule} from '@angular/material/dialog';
import {MatDividerModule} from '@angular/material/divider';
import {MatExpansionModule} from '@angular/material/expansion';
import {MatGridListModule} from '@angular/material/grid-list';
import {MatIconModule} from '@angular/material/icon';
import {MatInputModule} from '@angular/material/input';
import {MatListModule} from '@angular/material/list';
import {MatMenuModule} from '@angular/material/menu';
import {MatNativeDateModule, MatRippleModule} from '@angular/material/core';
import {MatPaginatorModule} from '@angular/material/paginator';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatRadioModule} from '@angular/material/radio';
import {MatSelectModule} from '@angular/material/select';
import {MatSidenavModule} from '@angular/material/sidenav';
import {MatSliderModule} from '@angular/material/slider';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import {MatSnackBarModule} from '@angular/material/snack-bar';
import {MatSortModule} from '@angular/material/sort';
import {MatTableModule} from '@angular/material/table';
import {MatTabsModule} from '@angular/material/tabs';
import {MatToolbarModule} from '@angular/material/toolbar';
import {MatTooltipModule} from '@angular/material/tooltip';

import {A11yModule} from '@angular/cdk/a11y';
import {BidiModule} from '@angular/cdk/bidi';
import {ObserversModule} from '@angular/cdk/observers';
import {OverlayModule} from '@angular/cdk/overlay';
import {PlatformModule} from '@angular/cdk/platform';
import {PortalModule} from '@angular/cdk/portal';
import {CdkStepperModule} from '@angular/cdk/stepper';
import {CdkTableModule} from '@angular/cdk/table';
import { DataDialogComponent } from './shared/data-dialog/data-dialog.component';
import { FileDialogComponent } from './shared/file-dialog/file-dialog.component';
import { ComboDialogComponent } from './shared/combo-dialog/combo-dialog.component';
import { ReportsComponent } from './reports/reports.component';
import { UsersComponent } from './users/users.component';
import { WaitingDialogComponent } from './shared/waiting-dialog/waiting-dialog.component';
import { MessDialogComponent } from './shared/mess-dialog/mess-dialog.component';
import { MapsCandeactiveGuardService } from './services/maps-candeactive-guard.service';
import { FilterDialogComponent } from './shared/filter-dialog/filter-dialog.component';
import { TagComponent } from './tag/tag.component';
import { QRCodeModule } from 'angularx-qrcode';
import { ImgDialogComponent } from './shared/img-dialog/img-dialog.component';
import { ConfirmDialogComponent } from './shared/confirm-dialog/confirm-dialog.component';
import { NgxBarcodeModule } from 'ngx-barcode';
registerLocaleData(localePl);

@NgModule({
  exports: [
    // CDK
    A11yModule,
    BidiModule,
    ObserversModule,
    OverlayModule,
    PlatformModule,
    PortalModule,
    CdkStepperModule,
    CdkTableModule,

    // Material
    MatAutocompleteModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatCardModule,
    MatCheckboxModule,
    MatChipsModule,
    MatDatepickerModule,
    MatDialogModule,
    MatExpansionModule,
    MatGridListModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatMenuModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatRippleModule,
    MatSelectModule,
    MatSidenavModule,
    MatSlideToggleModule,
    MatSliderModule,
    MatSnackBarModule,
    MatStepperModule,
    MatTableModule,
    MatTabsModule,
    MatToolbarModule,
    MatTooltipModule,
    MatNativeDateModule,
  ],
  declarations: [UsersComponent],

})
export class MaterialModule {}

@NgModule({
  declarations: [
    AppComponent,
    MenuComponent,
    ToolbarComponent,
    InfoComponent,
    ItemslistComponent,
    WarehousesComponent,
    PieChartComponent,
    MapsComponent,
    ItemdetailsComponent,
    ReportsComponent,
    TagComponent,
    StatusinfoDirective,
    HistoryComponent,
    LoginpageComponent,
    RenameDialogComponent,
    DataDialogComponent,
    FileDialogComponent,
    ComboDialogComponent,
    WaitingDialogComponent,
    MessDialogComponent,
    FilterDialogComponent,
    ImgDialogComponent,
    ConfirmDialogComponent
  ],
  imports: [
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    ChartsModule,
    AngularFireModule.initializeApp(environment.firebase, 'angularfs'),
    AngularFirestoreModule,
    AngularFireAuthModule,
    QRCodeModule,
    NgxBarcodeModule
    //NgxFileHelpersModule
  ],

  entryComponents: [WaitingDialogComponent, RenameDialogComponent,
    DataDialogComponent,
    FileDialogComponent,
    ComboDialogComponent,
    WaitingDialogComponent,
    MessDialogComponent,
    FilterDialogComponent,
    ImgDialogComponent,
    ConfirmDialogComponent],
  providers: [{ provide: LOCALE_ID, useValue: 'pl' }, AngularFireStorage, ItemdetailsCandeactiveGuardService, MapsCandeactiveGuardService],
  bootstrap: [AppComponent]
})

export class AppModule { }
